import type { View } from '../App';
import { IconBuilding, IconCalendar, IconChat, IconContract, IconGloss, IconHome, IconOrg, IconTasks, IconWallet } from '../components/icons';

/*
 * Разделы приложения одним списком: левое меню, нижняя полоса, «Ещё» и
 * плитки Главной берут название и иконку отсюда, а не держат по своей карте.
 * Порядок — порядок левого меню. Открыт ли раздел, решает `viewAllowed`
 * (App.tsx): у «Функций» — любой из пяти разделов функций, у прочих — своя
 * запись реестра, у Главной кода нет.
 */
export const SECTIONS: { v: View; title: string; Icon: () => JSX.Element }[] = [
  { v: 'home', title: 'Главная', Icon: IconHome },
  { v: 'projects', title: 'Функции', Icon: IconBuilding },
  { v: 'calendar', title: 'Календарь', Icon: IconCalendar },
  { v: 'chat', title: 'Чат', Icon: IconChat },
  { v: 'contracts', title: 'Договоры', Icon: IconContract },
  // у «Функций» уже стоит здание; «Наши юрлица» — состав группы, как оргструктура
  { v: 'legal', title: 'Наши юрлица', Icon: IconOrg },
  { v: 'tasks', title: 'Мои задания', Icon: IconTasks },
  // реестры платёжных дней и заявки на оплату (спека 2026-10-07)
  { v: 'finance', title: 'Финансы', Icon: IconWallet },
  { v: 'kb', title: 'База знаний', Icon: IconGloss },
];

export const sectionOf = (v: View) => SECTIONS.find((s) => s.v === v);
